var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVideoPlayIcon = function SvgVideoPlayIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M23.379 12.065A11.32 11.32 0 0 0 12.065.75 11.32 11.32 0 0 0 .75 12.065 11.32 11.32 0 0 0 12.065 23.38 11.32 11.32 0 0 0 23.38 12.065z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m17.138 11.15-7.73-4.751a.71.71 0 0 0-.707-.013.7.7 0 0 0-.358.61v9.458c0 .252.137.486.354.61a.7.7 0 0 0 .34.088.7.7 0 0 0 .362-.102l7.73-4.711a.7.7 0 0 0 .336-.592.67.67 0 0 0-.327-.597"
  })));
};
export default SvgVideoPlayIcon;